module.exports = __webpack_public_path__ + "c_static/img/2-1手机天猫购物车.cc8d692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/2-1手机天猫购物车.jpg
// module id = 4skQ
// module chunks = 33